import React from 'react';
import { FaLinkedin, FaInstagram, FaGithub } from 'react-icons/fa';
import { BiLogoGmail } from 'react-icons/bi';

import './Footer.css';
export default function Footer() {
  return (
    <footer className='footer'>
      <div className='footer-container'>
        <div className='social-handles'>
          <a target='_blank' href='mailto:pankajasiwal11828@gmail.com'>
            <BiLogoGmail />
          </a>
          <a target='_blank' href='https://www.linkedin.com/in/pankaj-asiwal-a7611a1aa/'>
            <FaLinkedin />
          </a>
          <a target='_blank' href='https://github.com/pankajasiwal'>
            <FaGithub />
          </a>
          <a target='_blank' href='https://www.instagram.com/pankaj_asiwal05/'>
            <FaInstagram />
          </a>
        </div>
        <div className='resume-btn'>
          <button>
            <a
              target='_blank'
              href='https://drive.google.com/file/d/1IxExopVrff4n8JNH2QMUpe8BfURimUUH/view?usp=sharing'
            >
              Resume
            </a>
          </button>
        </div>
        <p className='footer-subheading'>Made by Pankaj Asiwal @2023 || Maintenance Required.</p>
      </div>
    </footer>
  );
}
